import { navigateTo } from "scrivito"
import { useEvent } from "shared/lib/useEvent"

import { useNavigateToProduct } from "entities/products/model/useNavigateToProduct"
import { useNavigateToProject } from "entities/projects/model/useNavigateToProject"
import {
  GlobalSearchOption,
  GlobalSearchResultType
} from "features/global-search/types/GlobalSearch"

export function useNavigateToGlobalSearchResult() {
  const navigateToProduct = useNavigateToProduct(null)
  const navigateToProject = useNavigateToProject(null)

  return useEvent((option: GlobalSearchOption | null) => {
    if (!option) {
      return
    }
    switch (option.type) {
      case GlobalSearchResultType.PROJECT:
        navigateToProject({ id: option.value })
        break
      case GlobalSearchResultType.PRODUCT:
        if (option.data.variantKey) {
          navigateToProduct({ variantKey: option.data.variantKey })
        } else {
          navigateTo(option.data.obj)
        }
        break
      case GlobalSearchResultType.BUILDING_REFERENCE:
        navigateTo(option.data.obj)
        break
      default:
        break
    }
  })
}
